import o from "./highrise643.mjs";
import i from "./highrise1299.mjs";
import m from "./highrise1615.mjs";
import f from "./highrise1449.mjs";
function c(r, t) {
  return o(r) ? r : i(r, t) ? [r] : m(f(r));
}
export {
  c as default
};
